import React from 'react';
import { Checkbox } from '../../atoms/checkbox/checkbox';
import { InfoTooltip } from '../../atoms/tooltip/prebuilt/info-tooltip/info-tooltip';
import Label from '../../atoms/typography/Label/label';

interface ILabeledCheckboxProps {
	label?: string;
	description?: string;
}

const LabeledCheckbox: React.FC<ILabeledCheckboxProps & React.ComponentProps<typeof Checkbox>> = ({
	label,
	description,
	...props
}) => {
	return (
		<div className="flex flex-row items-center gap-2">
			<Checkbox {...props} />
			{label && <Label htmlFor={props.id} label={label} weight="medium" />}
			{description && <InfoTooltip content={description} />}
		</div>
	);
};

export { LabeledCheckbox };
